import { ItemsPerPage } from '@billy/design-system'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { BillState } from '@features/bills/enums/billState'
import { BillStatus } from '@features/bills/enums/billStatus'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../../../../config/queryClient'
import { fetchBills } from '../../../../query-api'
import { BillsQueryProps } from '../../../../types/billsQueryProps'
import { getBillsQueryKey } from '../../../../utils/getBillsQueryKey'

export const useIsBillsListEmpty = (): boolean => {
  const { organization } = useUserOrganization()

  const queryProps: BillsQueryProps = useMemo(
    () => ({
      page: 1,
      pageSize: 1 as ItemsPerPage,
      status: BillStatus.All,
      organizationId: organization?.id as string,
      state: [BillState.Approved, BillState.Draft],
    }),
    [organization],
  )

  const queryKey = useMemo(() => getBillsQueryKey(queryProps), [queryProps])

  const { data: billsCountData, isFetched: billsCountFetched } = useQuery(queryKey, () => fetchBills(queryProps), {
    enabled: !!organization,
    staleTime: defaultStaleTime,
  })

  return billsCountFetched && billsCountData?.bills.length === 0
}
